import { realEstateDescriptionFields } from '../../common/forms/generalRealEstate/fields'

export const AI_VALUE_ENDPOINTS = {
    emphasis: 'v1/ai/values/aiDescriptionEmphasis',
} as const

export const aiDescriptionFieldsConfig = {
    emphasis: realEstateDescriptionFields.PROPERTY_DESCRIPTION_EMPHASIS,
}
